import { LnAuth } from '@ln/auth0-js';

// environments
import { environment } from './../environments/environment';

// Constants
import { APP_CONFIG } from './../constants/config.constant';

// Services
import { StorageService } from './storage.service';

// Helpers
import { errorHandler } from './../helpers';

export const AuthService = {

    authConfig: () => {

        const authConfig = LnAuth({

            domain: environment.apiLogin.endpoint,
            clientId: environment.apiLogin.clientId,
            audience: environment.apiLogin.audience,
            cacheLocation: 'localStorage',
            connection: environment.apiLogin.connection,
            useRefreshTokens: APP_CONFIG.GUARDS.AUTH.REFRESH_TOKEN
        });

        return authConfig;
    },

    login: async (username, password) => {

        try {

            const authConfig = AuthService.authConfig();
            await authConfig.logInAsync({ mode: 'api', username, password });

            const user = await authConfig.getUserDataAsync();
            const accessToken = await authConfig.getAccessTokenAsync();

            return {
                user, 
                accessToken
            };

        } catch (error) {

            throw errorHandler(error, 'AUTH');
        }
    },

    logout: async () => {

        const authConfig = AuthService.authConfig();
        await authConfig.logOutAsync();
        
        StorageService.clear();
    },

    getUserData: async () => {

        try {

            const authConfig = AuthService.authConfig();
            const data = await authConfig.getUserDataAsync();            

            return data;

        } catch (error) {

            throw errorHandler(error, 'AUTH');
        }
    },

    getAccessToken: async () => {

        try {

            const authConfig = AuthService.authConfig();
            const accessToken = await authConfig.getAuthorizationHeaderAsync();

            return accessToken;

        } catch (error) {

            throw errorHandler(error, 'AUTH');
        }
    },

    isAuthenticated: async () => {

        try {

            const authConfig = AuthService.authConfig();
            const isAuthenticated = await authConfig.isAuthenticatedAsync();

            return isAuthenticated;

        } catch (error) {

            return false;
        }
    },

    resetPassword: async (email) => {

        try {
            
            const authConfig = AuthService.authConfig();
            await authConfig.changePasswordAsync( {email} );            

        } catch (error) {

            throw errorHandler(error, 'AUTH');
        }
    }
};